// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lobby[data-v-f2af6b8c]{display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
